import React from "react";
import PageWrapper from "components/PageWrapper";
import DocumentCategoryTable from "./document-category-table";

function DocumentCategory() {
  return (
    <PageWrapper>
      <DocumentCategoryTable />
    </PageWrapper>
  );
}

export default DocumentCategory;
